import { memoize } from '../cache'

export const getNumberFormat = memoize(
  (...args: ConstructorParameters<typeof Intl.NumberFormat>) =>
    Intl.NumberFormat(...args),
  (...args: ConstructorParameters<typeof Intl.NumberFormat>) =>
    JSON.stringify(args)
)
